import { ComponentPropsWithoutRef, FC } from 'react';
import { useZoomableContext } from '../../context/ZoomableContext';

interface ZoomableContentProps extends ComponentPropsWithoutRef<'div'> {}

const ZoomableContent: FC<ZoomableContentProps> = (props) => {
    const { children, ...rest } = props;

    const { refs } = useZoomableContext();

    return (
        <div {...rest} ref={refs.content.setReference}>
            {children}
        </div>
    );
};

export default ZoomableContent;
